import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Pin Column icon — pushpin.
 * Exported 1:1 from Figma (node 5124:195038 — Bombiix 2026). Uses
 * `stroke=currentColor` so the parent drives the tint.
 */
const PinColumnIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M2.6666 13.3331L5.99993 9.99977M3.13801 7.13784L8.86186 12.8617C9.05609 13.0559 9.3887 12.9451 9.42755 12.6731L9.93708 9.10642C9.97788 8.82082 10.1102 8.55616 10.3142 8.35217L11.6094 7.05696C11.8595 6.80691 12.1986 6.66644 12.5522 6.66644H13.1952C13.4922 6.66644 13.6409 6.30739 13.4309 6.0974L9.9023 2.56881C9.69231 2.35882 9.33327 2.50754 9.33327 2.80451V3.44749C9.33327 3.80111 9.19279 4.14025 8.94274 4.3903L7.64754 5.6855C7.44354 5.8895 7.17888 6.02183 6.89329 6.06263L3.32657 6.57216C3.05465 6.611 2.94378 6.94361 3.13801 7.13784Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

export default PinColumnIcon;
